<template>
    <div class="row">
      <LmEditor
        class="col-12 col-md-12"
        :contentProps="component.componentProps.html"
        @onUpdate="component.componentProps.html = $event; $emit('input', component)"
        :variablesOptions="[
          { id: 0, name: 'fecha', value: 'date' },
          { id: 1, name: 'nombre', value: 'name' }
        ]"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component)"
        label="Nombre"
        placeholder="Nombre"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        label="Ancho vista escritorio"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
    </div>
</template>

<script>
import LmEditor from '@/components/LmEditor.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
export default {
  data () {
    return {
      component: {}
    }
  },
  components: {
    LmEditor,
    LmTextInput,
    LmSelect
  },
  props: {
    componentData: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String
    }
  },
  methods: {
    initializeComponent () {
      this.component = this.componentData
    }
  },
  created () {
    this.initializeComponent()
  }
}
</script>
